import React from 'react'
import { getDSCInitialState, DSCReducer, ACTIONS } from './DSCReducer'
import { getSessionStorageItem } from '../shared/helpers/sessionStorage'

const DSCStateContext = React.createContext()
const DSCDispatchContext = React.createContext()

function DSCProvider({ children }) {
  const cachedNonstandardUser = getSessionStorageItem('nonstandardUser')
  const cachedCountry = getSessionStorageItem('customCountry')

  const [DSCGlobalState, DSCGlobalDispatch] = React.useReducer(
    DSCReducer,
    getDSCInitialState({ cachedCountry, cachedNonstandardUser })
  )
  return (
    <DSCStateContext.Provider value={DSCGlobalState}>
      <DSCDispatchContext.Provider value={DSCGlobalDispatch}>{children}</DSCDispatchContext.Provider>
    </DSCStateContext.Provider>
  )
}

function useDSCState() {
  const context = React.useContext(DSCStateContext)
  if (context === undefined) {
    throw new Error('ERROR: useDSCState must be used inside of DSCProvider')
  }
  return context
}

function useDSCDispatch() {
  const context = React.useContext(DSCDispatchContext)
  if (context === undefined) {
    throw new Error('ERROR: useDSCDispatch must be used inside of DSCProvider')
  }
  return context
}

export { DSCProvider, useDSCState, useDSCDispatch, ACTIONS }
